import React from 'react';
import PropTypes from 'prop-types';
import 'react-loading-skeleton/dist/skeleton.css';
import PublicAssignmentPropertiesTable from './PublicAssignmentPropertiesTable';
import Modal from '../../../components/Modal';
import Modals from '../pages/ManageAssign/components/StudentSessionReport/components/Modals';
import { useGetViewStandardMutation } from '../../../features/authentication/reportApiSlice';
import QuestionPreviewModal from './QuestionPreviewModal';
import TableSkeleton from '../../../components/SkeletonLoader/TableSkeleton';

const PropertiesModal = ({
  title,
  assignmentId,
  properties,
  openProperties,
  setOpenProperties,
  isLoading,
  isPublicAssignment,
  isSetPreview,
  qSetId
}) => {
  const [openStandardModal, setOpenStandardModal] = React.useState(false);
  const [getViewStandard] = useGetViewStandardMutation();
  const [viewStandardDetails, setViewStandardDetails] = React.useState({});
  const [openQuestionDetailModel, setOpenQuestionDetailModel] = React.useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(null);
  const [questionNo, setQuestionNo] = React.useState(null);

  const handleStandard= async (standard)=>{
    const option = {
      stateCourseId: parseInt(standard.stateCourseId),
      standardNumber: String(standard.standardNumber),
      stateId: standard.stateId
    };
    try {
      const { data } = await getViewStandard(option);
      setViewStandardDetails(data);
      setOpenStandardModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleQuestionDetails = (questionId, questionNo) => {
    setSelectedQuestionId(questionId);
    setOpenQuestionDetailModel(true);
    setQuestionNo(questionNo);
  };
  return (
    <>
      <Modal
        contentWidth="1400px"
        isOpen={openProperties}
        const titleName = {!isSetPreview ? `Assignment Properties: ${title}` 
          : (`PCS/Assessment Set Properties <span>(${title})</span>`)}
        onClose={() => setOpenProperties(false)}>
        {isLoading ?(
          <TableSkeleton
            rowCount={6}
            colCount={3}
            tableClass={'pt-4'}
            skeletonClass={'pt-2'}/>
        ):(<>
          {isPublicAssignment && properties?.ownerName?.length> 0 &&
          <div className="mb-4">
            <span className="primary-title">Owner:</span>{' '}
            {properties.ownerName}
          </div>
          }
          {properties?.properties &&(
            <>
              {properties.properties.map((item,index)=>(
                <>
                  <div className={`assignment-properties ${index>0?'mt-5':''}`}>
                    <div className="mb-4">
                      <span className="primary-title">{item.courseName}</span>
                    </div>
                    {item.publicAssignmentTopics?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentTopics}
                        tableHead="Topics"
                      />
                    )}

                    {item.publicAssignmentTags?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentTags}
                        tableHead="Tags"
                      />
                    )}

                    {item.publicAssignmentLevels?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentLevels}
                        tableHead="Difficulty Level"
                      />
                    )}

                    {item.publicAssignmentAttributes?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentAttributes}
                        tableHead="Attribute"
                      />
                    )}
                    {item.publicAssignmentStandards?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentStandards}
                        tableHead="Standard"
                        assignmentId={assignmentId}
                        isPublicAssignment={isPublicAssignment}
                      />
                    )}

                    {item.publicAssignmentQtypes?.length !== 0 && (
                      <PublicAssignmentPropertiesTable
                        loading={isLoading}
                        publicArray={item.publicAssignmentQtypes}
                        tableHead="Question Type"
                      />
                    )}
                  </div>
                </>
              ))}
              {properties?.publicAssignmentQuestionIds && (
                <>
                  <div className="mb-4 mt-4">
                    <span className="primary-title">Question IDs</span>
                  </div>

                  <div className="custom-table table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Question</th>
                          <th>Course</th>
                          <th>Question Id</th>
                          <th>Standards</th>
                          {!isSetPreview?<th>PCS Sets</th>:<th>Other PCS Sets</th>}
                          <th>Set Owner</th>
                          <th>Question # in set</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          properties.publicAssignmentQuestionIds?.map(
                            (item, index) => (
                              <tr key={`public-questions-${item.questionId}`}>
                                <td className='text-decoration-underline cursor-pointer text-castleRed' onClick={()=> handleQuestionDetails(item.questionId, index+1)}> {index + 1} </td>
                                <td> {item.courseName} </td>
                                <td> {item.questionId}</td>
                                <td>
                                  {item.standards?.map((value, key) => (
                                    <span onClick={()=>handleStandard(value)} className='text-decoration-underline cursor-pointer text-castleRed' key={`standard-${key}`}>{value.standardNumber}{key!==item.standards?.length-1?' ,':''}</span>
                                  ))}
                                </td>
                                <td>
                                  {item.setDeatils?.map((value, key) => (
                                    <div key={`pcsSets-${key}`}>{value.pcsSets}</div>
                                  ))}
                                </td>
                                <td>
                                  {item.setDeatils?.map((value, key) => (
                                    <div key={`setOwner-${key}`}>{value.setOwner}</div>
                                  ))}
                                </td>
                                <td>
                                  {item.setDeatils?.map((value, key) => (
                                    <div key={key}>{value.questionInSet}</div>
                                  ))}
                                </td>
                              </tr>
                            )
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              <div className="d-flex justify-content-end mt-3">
                <button disabled className="btn btn-castleRed print-btn">
                  Print
                </button>
              </div>
            </>
          )}
        </>
        )}
      </Modal>
      <Modals
        isOpen={openStandardModal}
        onClose={() => setOpenStandardModal(false)}
        details={viewStandardDetails}
      />

      <QuestionPreviewModal
        isOpen={openQuestionDetailModel}
        onClose={() => setOpenQuestionDetailModel(false)}
        questionId={selectedQuestionId}
        assignmentId={parseInt(assignmentId)}
        isPublicAssignment={isPublicAssignment}
        isSetPreview={isSetPreview}
        questionNo={questionNo}
        qSetId={qSetId}
      />
    </>
  );
};

PropertiesModal.propTypes = {
  title: PropTypes.string,
  properties: PropTypes.object,
  setOpenProperties: PropTypes.func,
  openProperties:PropTypes.bool,
  isLoading:PropTypes.bool,
  assignmentId:PropTypes.number,
  isPublicAssignment:PropTypes.bool,
  isSetPreview: PropTypes.bool,
  qSetId: PropTypes.number
};

export default PropertiesModal;
